import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TCreateFinixMerchantRequestSchema,
  TCreateFinixMerchantResponseSchema,
} from "./createFinixMerchant.schema";

export const createFinixMerchant = (axios: IAxiosInstance) => {
  return async (body: TCreateFinixMerchantRequestSchema) => {
    const response = await axios.noRetry.post<
      IApiResponse<TCreateFinixMerchantResponseSchema>
    >(`/api/business-cards/merchant`, body);

    return response.data;
  };
};
